import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-customer-wallet-recharge',
    templateUrl: './customer-wallet-recharge.component.html',
    styleUrls: ['./customer-wallet-recharge.component.scss'],
    standalone: false
})
export class CustomerWalletRechargeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
